export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/fields${mapQueryString(query)}`),
    show: (id = {}) => axios.get(`/fields/${id}`),
    store: (data) => axios.post(`/fields`, data),
    update: (id, data) => axios.patch(`/fields/${id}`, data),
    delete: (id) => axios.delete(`/fields/${id}`),
})